import { BreakContent } from "../utils/BreakContent";
import { BuildFontString } from "../utils/BuildFontString";
import { SetCtxFont } from "../utils/SetCtxFont.js";
import {
  enumElementDrawStates,
  kCheckBoxMargin,
  kCheckBoxSize,
  kOCNTextColor,
  kRadioButtonVertSpacing
} from "../constants";
import { QElement } from "./QElement";
import { Globals } from "./Globals.js";

export class QToggleBox extends QElement {
  constructor() {
    super();
    this.fLabel = "<Not Set>";
    this.fChecked = false;
    this.fParentGroup = null;
    this.fTextColor = kOCNTextColor; // Color for active text
    //this.fShapeType = null;

    this.fFontSize = 12;
    this.fFontName = "Arial";
    this.fBold = false;

    this.fHideLabel = false;
    this.fMaxWidth = null;

    this.fLabel1 = null;
    this.fLabel2 = null;
  }

  InitToggleBox(parentGroup) {
    //this.fShapeType = shape;
    this.fParentGroup = parentGroup;
    this.fUIColors = Globals._wsMgr.GetUIColors();
    //this.SetChecked(isChecked);
  }

  SetMaxWidth(maxWidth) {
    this.fMaxWidth = maxWidth;
  }

  GetCursor() {
    return "pointer";
  }

  SetBold(bold) {
    this.fBold = bold;
  }

  SetFontSize(fontSize) {
    this.fFontSize = fontSize;
  }

  RenderButton(drawBuffer, fillStyle, borderStrokeStyle, checkColor, outerGlow) {}

  SetTextColor(textColor) {
    this.fTextColor = textColor;
  }

  SetHideLabel(hideLabel) {
    this.fHideLabel = hideLabel;
  }

  GetRealContent() {
    //Used to simplify true/false checks. Semi-dirty...
    return !this.IsChecked();
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var isChecked = this.IsChecked();
    // Fill for background of checkbox
    var drawState = this.GetDrawState();
    // Border of active checkbox
    var txtFillStyle = Globals._themeMode.text.header; // Color for active text
    var checkColor = this.fUIColors.GetPagingBlueColor();
    var outerGlow = checkColor;

    if (this.fLegacyMode) txtFillStyle = this.fTextColor;

    var fillStyle = isChecked
      ? this.fUIColors.GetPagingBlueColor()
      : this.fUIColors.GetTextEditFillColor();
    var borderStrokeStyle = isChecked
      ? this.fUIColors.GetPagingBlueColor()
      : Globals._themeMode.text.header;

    if (drawState === enumElementDrawStates.Disabled) {
      fillStyle = this.fUIColors.GetDisabledTextColor();
      borderStrokeStyle = fillStyle;
      txtFillStyle = fillStyle;
      ctx.globalAlpha = 0.7;
    }

    this.RenderButton(drawBuffer, fillStyle, borderStrokeStyle, checkColor, outerGlow);

    if (this.fHideLabel) return;

    ctx.fillStyle = txtFillStyle;

    var fS = BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    SetCtxFont(ctx, fS);
    ctx.textAlign = "left";
    ctx.textBaseline = "middle";
    var txtHOffset = kCheckBoxSize + kCheckBoxMargin * 2;

    if (this.fLabel1 == null) {
      var txt = this.fLabel;
      var txtVOffset = Math.floor(this.fHeight / 2) + 1;
      ctx.fillText(txt, this.fHorzOffset + txtHOffset, this.fVertOffset + txtVOffset);
    } else {
      var txtVOffset = 2;
      ctx.fillText(this.fLabel1, this.fHorzOffset + txtHOffset, this.fVertOffset + 2);
      txtVOffset += 12;
      ctx.fillText(this.fLabel2, this.fHorzOffset + txtHOffset, this.fVertOffset + txtVOffset);
    }

    ctx.shadowBlur = 0;
  }

  SetLabel(theLabel) {
    this.fLabel = theLabel;
  }

  IsIndeterminate() {
    return this.fIndeterminate;
  }

  SetIndeterminate(isIndeterminate) {
    this.fIndeterminate = isIndeterminate;
  }

  SetChecked(checked) {
    this.fChecked = checked;

    if (this.fParentGroup != null) this.fParentGroup.RadioButtonSelected(this);
  }

  PSetChecked(checked) {
    this.fChecked = checked;
  }

  IsChecked() {
    return this.fChecked;
  }

  DoCalculateMinWidth() {
    var ctx = this.fMeasureBuffer.getContext("2d");

    var fS = BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    SetCtxFont(ctx, fS);

    var txt = this.fLabel;
    var txtDim = ctx.measureText(txt);
    var txtWidth = Math.ceil(txtDim.width);

    txtWidth = txtWidth + kCheckBoxSize + kCheckBoxMargin * 2;
    return txtWidth;
  }

  AutoSize() {
    var minWidth = this.CalcMinWidth();
    var textHeight = 16;
    var rowH = kRadioButtonVertSpacing;

    if (this.fMaxWidth) {
      if (minWidth > this.fMaxWidth) {
        minWidth = this.fMaxWidth;
        textHeight += 12;
        rowH += 12;
        var fS = BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
        var p = BreakContent(this.fLabel, 2, minWidth, 0, 0, fS, " ");
        if (p.length == 2) {
          this.fLabel1 = p[0];
          this.fLabel2 = p[1];
        }
      }
    }

    this.SizeElement(minWidth, textHeight);

    return rowH;
  }
}
